module.exports = __webpack_public_path__ + "img/n7.5f0b8d0b.svg";